module.exports = __webpack_public_path__ + "static/media/9.0a5de6b2.svg";